import { AuthCallback } from '@onesource/components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/callback')({
  component: () => <AuthCallback redirectTo="/" errorRedirectTo="/auth/login" />,
});
